/*
Author: Vaishnavi
Date: 19/11/2019
Issue Description: Visual Bugs fixes assigned by Harshvardhan Kore & Tarun Bhandari,
spacing fixed in whole file. Used classes from margins.scss file
*/

/*
Author: Shivakumar
Date: 04/12/2019
Issue Description: [Onboarding V1.1][Salary Components]In Generate formula pop up, the formula is not getting refreshed.
search string: PL-1979
*/

/*
Author: Srinivas P
Date: 04/12/2019
Issue Description: of selecting calculationType as FLAT and changed the label of input from AMount to Annual Amount
search string: Line no 167
*/

/*
Author: Srinivas P
Date: 12/12/2019
Issue Description: Added None radio button for Deduction Label
search string: custom-width-radio for Deduction and
*/

/*
Author: Shivakumar
Date: 17/12/2019
Issue Description: On selecting part of CTC checkbox Fixed Gross should be selected by default.
search string: PL-1427
*/

/*
Author: Shivakumar
Date: 23/12/2019
Issue Description: Validation error message required for Pay Frequency while adding a new Salary Component.
*/

/*
Author: Shivakumar
Date: 23/12/2019
Issue Description: delete all the extra keys, which are not in use either in backend or frontend.
search string: PL-2322
*/

/*
Author: Vinod
Date: 22/01/2020
Issue Description: While Adding a New Salalry Component, By default Fixed gross should be selected in Part of CTC.
search string: PL_2509
*/

/*
Author: Shivakumar
Date:  06/03/2020
Issue Description: Calculation type is changed from Formula to Flat but still not changing in calculation type
search string: PL_2797
*/

/*
Author: Shivakumar
Date: 06/03/2020
Issue Description: Tax Exempt status is not displaying in Salary Components page.
search string: PL_2207
*/

/*
Author: Shivakumar
Date: 06/03/2020
Issue Description: Formula builder validation.
search string: PL_2789
*/

/*
Author: Shivakumar
Date: 10/03/2020
Issue Description: [Default Salary Component] Can not update transaction type of PF Employee Contribution, as the paytype is a disabled field.
search string: PL_2716
*/


<template>
  <div>
    <div class="preferences" v-if="!showSlabs">
      <div class="top-bar">
        <img @click="goBack" src="@/assets/path-2-copy.png" />
        <span class="heading_new">{{ pageHeaderText }}</span>
      </div>
      <div class="content-new">
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />
        <form action class="preferences-form">
          <div class="row">
            <div>
              <txt
                label="Name *"
                type="text"
                v-model="formData.name"
                name="salaryComponentName"
                :disabled="disableForm.name"
                data-vv-as="Name"
                v-validate="{required: true, max: nameMaxlength}"
                :classname="errors.has('salaryComponentName')"
                :errormsg="errors.first('salaryComponentName')"
              />
            </div>
            <div>
              <txt
                label="Abbreviation *"
                type="text"
                name="salaryComponentAbbrevation"
                v-model="formData.abbreviation"
                :disable="disableAbbrevation"
                data-vv-as="Abbrevation"
                v-validate="{required: true, max: nameMaxlength}"
                :classname="errors.has('salaryComponentAbbrevation')"
                :errormsg="errors.first('salaryComponentAbbrevation')"
              />
            </div>

            <div class>
              <span class="input-label">Effective Date *</span>
              <date-picker
                class="customwidth"
                @datevalue="(val)=>formData.effectiveDate = val"
                :value="formData.effectiveDate"
                name="effectiveDate"
                data-vv-as="Effective Date"
                v-validate="{required: true}"
                :classname="errors.has('effectiveDate')"
                :errormsg="errors.first('effectiveDate')"
                :dates-disabled="{to:new Date(leIncorporationDate)}"
              />
            </div>
          </div>
          <div class="row margintop-24">
            <div>
              <tl-select
                label="Round Off Value *"
                labelText="name"
                name="Round off Value"
                class="customwidth marginright-32"
                :options="roundOffData"
                v-model="formData.roundOffObj"
                @change="(val)=> formData.roundOffObj = val"
                :disabled="disableForm.roundOffObj"
                v-validate="{required: true}"
                :classname="errors.has('Round off Value')"
                :errormsg="errors.first('Round off Value')"
              ></tl-select>
            </div>
            <div class="selectdiv">
              <tl-select
                label="Transaction Type *"
                class="customwidth"
                labelText="name"
                name="Transaction Type"
                v-model="formData.transaction_type"
                :options="transactionTypeArray"
                @change="onTransactionTypeChange($event)"
                :disabled="disableForm.transaction_type"
                v-validate="{required: true}"
                :classname="errors.has('Transaction Type')"
                :errormsg="errors.first('Transaction Type')"
              ></tl-select>
            </div>

            <div>
              <div class="input-label">Component Type *</div>
              <div class="radio-button-section">
                <tl-radio
                  name="fixedOrVariable"
                  label="Fixed"
                  id="Fixed"
                  :value="true"
                  v-model="formData.fixed"
                  @change="onComponentTypeChange()"
                  :disabled="disableForm.fixed"
                />
                <tl-radio
                  name="fixedOrVariable"
                  label="Variable"
                  id="Variable"
                  :disabled="(formData.transaction_type && formData.transaction_type.name == 'None') || disableForm.fixed"
                  :value="false"
                  v-model="formData.fixed"
                  @change="onComponentTypeChange()"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Remove this disabled attribute in tl-select componenet below -->
            <!-- :disabled="disableForm.SalaryComponentType" -->
            <tl-select
              name="Pay Type"
              label="Pay Type *"
              class="customwidth marginright-32 margintop-24"
              labelText="name"
              :options="SalaryComponentTypesArray"
              v-model="formData.SalaryComponentType"
              @change="(val)=>{formData.SalaryComponentType = val; onPayTypeChange(val)}"
              v-validate="{required: true}"
              :classname="errors.has('Pay Type')"
              :errormsg="errors.first('Pay Type')"
            ></tl-select>

            <tl-select
              class="customwidth margintop-24"
              label="Calculation Type *"
              labelText="name"
              name="Calculation Type"
              :options="calculationTypeData"
              v-model="formData.CalculationType"
              @change="(val)=>changeCalculationType(val)"
              :disabled="disableForm.CalculationType"
              v-validate="{required: true}"
              :classname="errors.has('Calculation Type')"
              :errormsg="errors.first('Calculation Type')"
            ></tl-select>

            <div v-if="formData.CalculationType == 'Formula' || formData.CalculationType == 'Flat'">
              <div class="input-label" v-if="formData.CalculationType == 'Formula'">Formula</div>
              <div class="input-label" v-if="formData.CalculationType == 'Flat'">Annual Amount (Rs.)</div>
              <div class="selectdiv">
                <textarea
                  v-if="formData.CalculationType == 'Formula'"
                  class="form-control"
                  name="formulaCalculation"
                  v-model="formData.formula"
                  :disabled="disableForm.formula"
                />
                <!-- PL_2797 -->
                <input
                  autocomplete="off"
                  type="number"
                  v-if="formData.CalculationType == 'Flat'"
                  class="form-control"
                  name="amount"
                  maxlength="9"
                  v-numeric-only
                  v-model="formData.formula"
                  :disabled="disableForm.formula"
                />
                <!-- PL_2797 -->
              </div>

              <div v-if="formData.CalculationType == 'Formula'">
                <p
                  :disabled="disableForm.formula"
                  class="anc-paragraph"
                  @click="generateFormula"
                >Generate Formula</p>
              </div>
            </div>

            <div />
            <div />
            <div />
            <!-- <span
              v-if="formData.CalculationType == 'Slab'"
              class="slabsClass"
              @click="addSlab()"
              :disabled="disableForm.formula"
            >View Slabs</span>
            <div />
            <div />
            <div class="line" v-if="formData.CalculationType == 'Slab'" /> -->
          </div>

          <!-- Other Settings -->
          <div class="formsubheader margintop-16">Other Settings</div>

          <div class="threeColumnGrid label">
            <div>
              <tl-checkbox
                class="headcheck"
                v-if="formData.SalaryComponentType!='FBP Component'"
                name="active"
                label="Active"
                :disabled="disableForm.active"
                v-model="formData.active"
              />
              <tl-checkbox
                class="headcheck"
                name="allow_auto_claim"
                v-if="formData.SalaryComponentType=='FBP Component'"
                label="Allow auto claim"
                v-model="formData.allow_auto_claim"
              />
            </div>
            <div>
              <tl-checkbox
                class="headcheck"
                name="part_of_ctc"
                label="Part of CTC"
                :disabled="(( disableForm.part_of_ctc || formData.fixed == 'false' || formData.fixed == false) || formData.SalaryComponentType == 'Loan') || (formData.SalaryComponentType == 'Overtime')"
                v-if="formData.SalaryComponentType!='FBP Component'"
                v-model="formData.part_of_ctc"
                @change="(val)=>{formData.part_of_ctc = val; onPartOfCTCchange(val)}"
              />

              <!-- || ((formData.fixed == true || formData.fixed == 'true')  && formData.SalaryComponentType == 'Statutory' && formData.transaction_type == 'None') -->
              <!-- <div
                class="marginleft-5p display-flex margintop-8"
                v-if="(formData.part_of_ctc)  && (formData.SalaryComponentType != 'Statutory')"
              >
                <tl-radio
                  name="PartOfCTC"
                  label="Fixed Gross"
                  id="Fixedgross"
                  :value="'FixedGross'"
                  checked
                  v-model="formData.ctcSubSection"
                  :disabled="disableForm.ctcSubSection"
                />
                <tl-radio
                  name="PartOfCTC"
                  label="Variable Pay"
                  id="variablepay"
                  :value="'Variable'"
                  v-model="formData.ctcSubSection"
                  :disabled="disableForm.ctcSubSection"
                />
              </div> -->
              <tl-checkbox
                class="headcheck"
                name="allow_lower_declaration"
                v-if="formData.SalaryComponentType=='FBP Component'"
                label="Allow lower declaration"
                v-model="formData.allow_lower_declaration"
                :disable="disableForm.allow_lower_declaration"
              />
            </div>
            <div>
              <tl-checkbox
                class="headcheck"
                name="consider_esi_eligibility"
                label="Consider for ESI Eligibility"
                v-model="formData.consider_esi_eligibility"
                v-if="formData.SalaryComponentType!='FBP Component'"
                :disable="disableForm.consider_esi_eligibility"
              />

              <tl-checkbox
                class="headcheck"
                name="allow_annual_claim"
                v-if="formData.SalaryComponentType=='FBP Component'"
                label="Allow annual claim"
                v-model="formData.allow_annual_claim"
                :disable="disableForm.allow_annual_claim"
              />   
          </div>

            <div>
              <tl-checkbox
                class="headcheck"
                name="not_attendance_dependant"
                label="Dependent on Attendance"
                v-model="formData.not_attendance_dependant"
                @change="depedentOnAttendanceClicked($event)"
                :disable="disableForm.not_attendance_dependant"
              />

              <div class="label marginleft-10p">
                <tl-checkbox
                  class="headcheck"
                  label="Payable even if absent full month"
                  v-model="formData.payable_if_full_lop"
                  v-bind:disable="!formData.not_attendance_dependant || disableForm.payable_if_full_lop"
                />

                <div>
                  <tl-checkbox
                    class="headcheck marginleft-90p"
                    name="paid"
                    label="Paid Component"
                    v-if="formData.SalaryComponentType!='FBP Component'"
                    v-model="formData.paid"
                    :disable="disableForm.paid"
                  />
                  <tl-checkbox
                    class="headcheck marginleft-90p"
                    name="carry_forward_next_fbp_year"
                    v-if="formData.SalaryComponentType=='FBP Component'"
                    label="Carry forward unclaimed amount to next FBP year"
                    v-model="formData.carry_forward_next_fbp_year"
                    :disable="disableForm.carry_forward_next_fbp_year"
                  />

                </div>

                <div>
                  <tl-checkbox
                    class="headcheck marginleft"
                    name="pt"
                    label="PT Applicability"
                    v-model="formData.pt_applicability"
                    v-if="formData.SalaryComponentType!='FBP Component'"
                    :disable="disableForm.pt_applicability"
                  />
                           <tl-select
                    class="payoutFrequency"
                    label="Payout Frequency"
                    labelText="name"
                    :options="payoutFrequencyOptions"
                    @change="(val) => formData.PayoutFrequency = val"
                    v-if="formData.SalaryComponentType=='FBP Component'"
                    :disable="disableForm.PayoutFrequency"
                  ></tl-select>  
                </div>
                <div class="flex margintop-30 margintop-56">
                  <tl-checkbox
                   v-if="formData.SalaryComponentType!='FBP Component'"
                    class="headcheck add-flex-new-basis"
                    v-model="formData.payable_if_employee_have_joined_before_a_date"
                    name="payable_if_employee_have_joined_before_a_date"
                    label="Payable only if joined before"
                    v-bind:disable="!formData.not_attendance_dependant || formData.SalaryComponentType=='FBP Component' || disableForm.payable_if_employee_have_joined_before_a_date"
                   
                  />

                  <tl-select
                    class="custom-width-100"
                    :options="joinedAfterData"
                    :value="formData.cutoffDays"
                    @change="(val)=>formData.cutoffDays = val"
                    v-bind:disable="!formData.not_attendance_dependant || formData.SalaryComponentType=='FBP Component' || disableForm.payable_if_employee_have_joined_before_a_date"
                    v-if="formData.SalaryComponentType!='FBP Component'"
                  ></tl-select>
                </div>

                <div class="customheadcheck">
                  <br />
                  <tl-checkbox
                    class="headcheck marginleft-90p"
                    name="gross_up_tax"
                    label="Gross up tax"
                    v-model="formData.gross_up_tax"
                    v-if="formData.SalaryComponentType!='FBP Component'"
                    :disable="disableForm.gross_up_tax"
                  />
                  <tl-checkbox
                    class="headcheck marginleft-90p"
                    name="allow_full_claims_any_time"
                    v-if="formData.SalaryComponentType=='FBP Component'"
                    label="Allow full claims anytime of the year"
                    v-model="formData.allow_full_claims_any_time"
                    :disable="disableForm.allow_full_claims_any_time"
                  />
                </div>

                <div :class="{'marginleft-90p payFrequency': formData.SalaryComponentType!=='FBP Component'}">

                </div>
                <div>
                  <div
                    :class="{'input-label-tax': formData.SalaryComponentType=='FBP Component' , 'taxstatusClass': formData.SalaryComponentType!='FBP Component'}"
                  >Tax Status</div>
                  <div class="twoColumnGrid-tax margintop-24">
                    <div class="radio-group">
                      <tl-radio
                        name="isTaxable"
                        label="Taxable"
                        id="Taxable"
                        :value="(formData.SalaryComponentType !== 'Reimbursement') && true"
                        v-model="formData.taxable"
                        v-on:change="onTaxStatusChange(formData.taxable)"
                        selected
                        :disabled="disableForm.taxable || (formData.SalaryComponentType == 'Reimbursement')"
                      />
                      <!-- PL_2207 -->
                    </div>
                    <br/>
                    <div class="check marginleft-30 radio-margin-top--20">
                      <tl-checkbox
                        class="headcheck"
                        label="Tax is distributed across the year"
                        :disable="(formData.taxable == 'false' || formData.taxable == false) || disableForm.tax_distributed_across_year"
                        v-model="formData.tax_distributed_across_year"
                      />
                    </div>
                    <div class="radio-group">
                      <!-- Remove this disabled attribute in tl-radio componenet below -->
                      <!-- :disabled="disableForm.taxable || !(formData.deductionName == 'None')" -->
                      <tl-radio
                        name="isTaxable"
                        label="NonTaxable"
                        id="NonTaxable"
                        :value="(formData.SalaryComponentType == 'Reimbursement') && false"
                        v-model="formData.taxable"
                        v-on:change="onTaxStatusChange(formData.taxable)"
                      />
                      <!-- PL_2207 -->
                    </div>
                    <br/>
                    <div class="radio-group margintop-24">
                      <tl-radio
                        name="isTaxable"
                        label="Partially taxable"
                        id="PartiallyTaxable"
                        v-if="formData.SalaryComponentType=='FBP Component'"
                        :value="'partially'"
                        v-model="formData.taxable"
                        :disabled="disableForm.taxable"
                      />
                    </div>
                     <tl-checkbox
                  class="headcheck margin-t-m"
                  name="is_exempted_under_new_tax_regime"
                  label="Is Exempted under New Tax Regime"
                  v-model="formData.is_exempted_under_new_tax_regime"
                />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <tl-checkbox
                class="headcheck"
                name="create_arrear_component"
                label="PF & PF Arrear"
                v-model="formData.create_arrear_component"
                v-if="formData.SalaryComponentType!='FBP Component'"
                :disable="disableForm.create_arrear_component"
              />
              <tl-checkbox
                class="headcheck"
                name="carry_forward_excess_bills"
                label="Allow carry forward of low/excess bills"
                v-model="formData.carry_forward_excess_bills"
                v-if="formData.SalaryComponentType=='FBP Component'"
                :disable="disableForm.carry_forward_excess_bills"
              />
            </div>

            <!-- Consider of ESI -->
            <div>
              <tl-checkbox
                class="headcheck"
                name="consider_esi_deduction"
                label="Consider for ESI Deduction"
                v-model="formData.consider_esi_deduction"
                v-if="formData.SalaryComponentType!='FBP Component'"
                :disable="disableForm.consider_esi_deduction"
              />
            </div> 
            <div>
              <tl-checkbox
                class="headcheck displayPayslip"
                name="reflect_this_in_payslip"
                label="Display in Payslip"
                v-model="formData.reflect_this_in_payslip"
                :disable="disableForm.reflect_this_in_payslip"
              />
              <tl-checkbox
                class="headcheck margin-t-m"
                name="is_fbp_component"
                label="Is FBP Component"
                v-model="formData.is_fbp_component"
              />
                <tl-checkbox
                class="headcheck ffs_component"
                name="allow_multiple_claims"
                label="Allow multiple claims"
                v-if="formData.SalaryComponentType=='FBP Component'"
                v-model="formData.allow_multiple_claims"
                :disable="disableForm.allow_multiple_claims"
              />
            </div>
            <div>
              <tl-checkbox
                class="headcheck ffs_component"
                name="is_ffs_component"
                label="Is FFS Component"
                v-model="formData.is_ffs_component"

              />
              <tl-checkbox
                v-if="formData.is_fbp_component"
                class="headcheck margin-t-m"
                name="fbp_newregime_applicable"
                label="Applicable to New Regime?"
                v-model="formData.fbp_newregime_applicable"
              />
            </div>

            <div class="margin-t-45px displayPayslip"></div>

            <div class="hidden">
              <tl-checkbox
                class="headcheck margin-t-15px"
                name="isPFEligible"
                label="Consider for PF Eligibility"
                v-model="formData.isPFEligible"
                :disable="disableForm.isPTEligible"
              />
            </div>
            <div class="hidden">
              <tl-checkbox
                class="headcheck margin-t-15px"
                name="isPTEligible"
                label="Consider for PT Eligibility"
                v-model="formData.isPTEligible"
                :disable="disableForm.isPTEligible"
              />
            </div>
            <!-- <div>
              <tl-checkbox
                class="headcheck margin-t-15px"
                name="supperAnnuationPerk"
                label="Super Annuation Perk"
                v-model="formData.supperAnnuationPerk"
              />
            </div>-->
          </div>
          <!-- Deductions -->
          <section class="sub-section displayDed margintop-35">
            <div class="label-text label-text-header margin-t-15px">Deductions</div>

            <div class="check margintop-10 row">
              <tl-radio
                name="deduction"
                v-model="formData.deductionName"
                class="custom-radio-width"
                label="Chapter VI A"
                id="deduction1"
                value="SectionVIA"
                ref="deductionValue"
                data-vv-as="Deductions"
                v-on:change="onDeductionChange(formData.deductionName)"
                :disabled="disableForm.deductionName"
              />
              <tl-radio
                name="deduction"
                class="custom-radio-width"
                label="Section 10"
                id="deduction2"
                value="Section10"
                v-model="formData.deductionName"
                ref="deductionValue"
                data-vv-as="Deductions"
                v-on:change="onDeductionChange(formData.deductionName)"
                :disabled="disableForm.deductionName"
              />
              <tl-radio
                name="deduction"
                class="custom-radio-width"
                label="Section 17"
                id="deduction3"
                value="Section17"
                v-model="formData.deductionName"
                ref="deductionValue"
                data-vv-as="Deductions"
                v-on:change="onDeductionChange(formData.deductionName)"
                :disabled="disableForm.deductionName"
              />
              <!-- start of added None radio option -->
              <tl-radio
                name="deduction"
                class="custom-radio-width"
                label="None"
                id="deduction4"
                value="None"
                v-model="formData.deductionName"
                ref="deductionValue"
                data-vv-as="Deductions"
                v-on:change="onDeductionChange(formData.deductionName)"
                :disabled="disableForm.deductionName"
              />
              <!-- end of added None radio Option -->
                  <div
                      class="customtaxable"
                      v-if="formData.taxable =='partially'"
                    >
                      <txt
                        label="Taxable %"
                        type="text"
                        id="max_value_field"
                        name="max_value_field"
                        v-model="taxable_per"
                        data-vv-as="Taxable"
                        v-validate="'max_value:100'"
                        @change="(val) => taxable_per = val"
                        :classname="errors.has('max_value_field')"
                        :errormsg="errors.first('max_value_field')"
                      />
                  </div>
            </div>
            <div class="margin-t-m twoColumnGrid">
              <div>
              <tl-select
                v-show="formData.deductionName!='None'"
                label="Map To *"
                labelText="name"
                :options="itSubSectionsArray"
                v-model="formData.itSubSectionObj"
                name="mapToItSubSectionSelection"
                @change="onItSubSectionChange($event)"
                :disable="disableForm.itSubSectionObj"
                data-vv-as="Map to"
                v-validate.immediate="'required_if:deductionValue,SectionVIA,Section10,Section17'"
                :classname="errors.has('mapToItSubSectionSelection')"
                :errormsg="errors.first('mapToItSubSectionSelection')"
              ></tl-select>
              </div>
           
            <div style="margin-top:25px">
              <tl-checkbox
                class="headcheck"
               v-show="formData.deductionName!='None'"
                name="visible_in_it_proof"
                label="Enable Mapping"
                :disabled="disableForm.visible_in_it_proof"
                v-model="formData.visible_in_it_proof"
              />
            </div>
          </div>
          </section>
          <!-- Deductions -->
        </form>
        <br />
        <br />

      <div class="btn-group">
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="goBack" />
              <btn :text="saveBtnText" type="primary" @click="save" />
            </btn-grp>
          </template>
        </bottom-action-container>
          </div>
      </div>
    </div>

    <!-- View Slabs UI -->
    <div class="business" v-if="showSlabs">
      <div class="top-bar">
        <span @click="backToAddSalaryComponent">
          <img @click="goBackFromSlabs" src="@/assets/path-2-copy.png" />
          <i class="left"></i>
        </span>
        <span class="heading_new">View Slabs</span>
      </div>
      <div class="margin-t-l"></div>
      <div class="margin-t-l">
        <div class="margin-t-l" v-for="(slab,index) in rangeSlabArray" :key="index">
          <span>
            <div class="flex-box">
              <div class="row-container">
                <b>Slab {{index+1}}</b>
              </div>
              <div class="row-container" v-if="rangeSlabArray.length > 1">
                <img class="margin-r-m" src="@/assets/delete.svg" />
                <button class="text-green" @click="deleteRangeSlab(index)">Delete Slab</button>
              </div>
            </div>
          </span>
          <br />
          <div class="range margin-t-l">
            <txt
              label="Min Value of Range"
              type="number"
              class="margin-r-s width-18per"
              v-model="slab.from"
              v-maxchars="9"
              v-numeric-only
              :name="`Minvalue for Slab ${index+1}`"
              v-validate="`required:${rangeSlabArray.length}|min_value:${Number((index > 0) ? (rangeSlabArray[index-1].to)+1 : 0)}|max_value:${Number(slab.to)}`"
              :classname="errors.has(`Minvalue for Slab ${index+1}`)"
              :errormsg="errors.first(`Minvalue for Slab ${index+1}`)"
            />
            <txt
              label="Max Value of Range"
              type="number"
              v-maxchars="9"
              v-numeric-only
              class="margin-r-s width-18per"
              v-model="slab.to"
              :name="`Maxvalue for Slab ${index+1}`"
              v-validate="`required:${rangeSlabArray.length}|min_value:${Number(slab.from ? slab.from+1 : 0)}|max_value:${Number(slab.to)}`"
              :classname="errors.has(`Maxvalue for Slab ${index+1}`)"
              :errormsg="errors.first(`Maxvalue for Slab ${index+1}`)"
            />
          </div>
          <div class="range margin-t-l">
            <txt
              label="Unit"
              type="text"
              class="margin-r-s width-18per"
              v-model="slab.unit"
              :name="'Unit'+index"
              v-validate="`required_if:${rangeSlabArray.length}`"
              @change="unitValueChanged($event)"
              :classname="errors.has('Unit'+index)"
              :errormsg="'Unit is required'"
            />
            <txt
              label="Salary Component Value"
              type="text"
              class="margin-r-s width-18per"
              v-model="slab.value"
              :name="'Value'+index"
              data-vv-as="value"
              v-validate="`required_if:${rangeSlabArray.length}|max:9`"
              :classname="errors.has('Value'+index)"
              :errormsg="errors.first('Value'+index)"
            />
          </div>
        </div>
        <div class="flex-box align-center margin-tb-l">
          <div class="row-container">
            <img src="@/assets/group-5.svg" />
            <button class="text-green" @click="addRangeSlab()">Make New Slab</button>
          </div>
        </div>
      </div>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Save" type="primary" @click="saveSlabs" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
    <!-- View Slabs UI Ended -->

    <pop-up-message
      v-if="showSuccessMsg"
      :message="popupMessage"
      btnText="Back to salary component"
      @back="backfrompopup()"
    />

    <!-- create formula modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Create Formula</h3>
        </div>
        <div class="modal-body">
          <div class="threeColumnGrid spacing threeColumnGrid-auto">
            <div class="form-group">
              <tl-select
                class="custom-width modal-custom-width-select"
                label="Brackets"
                :options="bracketsData"
                :value="formData.brackets"
                @change="brackets($event)"
              ></tl-select>
            </div>
            <div class="form-group">
              <tl-select
                class="custom-width modal-custom-width-select"
                label="Abbreviation"
                :options="newAbbreviationData"
                @change="abbreviation($event)"
              ></tl-select>
            </div>
            <div class="form-group">
              <tl-select
                class="custom-width modal-custom-width-select"
                label="Operators"
                :options="operatorsData"
                :value="formData.operators"
                @change="operators($event)"
              ></tl-select>
            </div>
          </div>
          <div class="twoColumnGrid">
            <div>
              <textarea class="form-control width-100" v-model="finalFormula"></textarea>
            </div>
            <div class="justify-content-center text-center" v-show="afterSavingExpression">
              <div v-show="isValidExpression">
                <img src="@/assets/checked.svg" class="status-image" alt="check" />
                <p class="status-text margintop-20">Valid Expression</p>
              </div>
              <div v-show="!isValidExpression">
                <img src="@/assets/warning_error.svg" class="status-image" alt="warning_error" />
                <p class="status-text margintop-20 color-red">Invalid Expression</p>
              </div>
            </div>
          </div>
          <div class="margintop-10">
            <p
              :disabled="!finalFormula.length"
              class="anc-paragraph"
              @click="onValidExpression()"
            >Validate</p>
          </div>
          <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelModal" />
              <btn
                :text="saveBtnText"
                type="primary"
                @click="saveExpression"
                :disabled="!isValidExpression"
              />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as constants from "@/apis/constants.js";
import * as config from "@/apis/config.js";

export default {
  name: "PreferencesAddNewComponent",
  props: {
    mode: {
      type: String,
      default: "add"
    },
    compData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      nameMaxlength: null,
      unit: "",
      calctypeenum: "",
      paytypeenum: "",
      popupMessage: "",
      showSlabs: false,
      rangeSlabArray: [],
      copyRangeSlabArray: [],
      errmsg: "",
      toast: false,
      taxable_per: "",
      afterSavingExpression: false,
      isValidExpression: false,
      joinedAfterData: Array.from(Array(31), (x, index) => index + 1),
      show: false,
      showSuccessMsg: false,
      showCreateModal: false,
      payoutFrequencyOptions: [],
      roundOffData: [],
      payFrequencyArray: [],
      calculationTypeData: [],
      transactionTypeArray: [],
      calculationOnData: [
        {
          name: "Deducted",
          id: false
        },
        {
          name: "Actual",
          id: true
        }
      ],

      SalaryComponentTypesArray: [],

      formData: {
        active: false,
        is_ffs_component:false,
        is_fbp_component: false,
        is_exempted_under_new_tax_regime:false,
        fbp_newregime_applicable: false,
        fixed: true,
        taxable: true,
        taxdist: false,
        pt_applicability: false,
        name: null,
        calculationTypeID: "",
        roundOffID: "",
        CalculationType: null,
        calculationOnActual: {},
        transaction_type: {},
        SalaryComponentType: "",
        roundOffObj: null,
        //PL-1427
        part_of_ctc: false,
        //PL-1427
        PayFrequency: null,
        ctcSubSection: null, // PL_2509
        fixedOrVariable: "FixedGross",
        itSectionObj: null,
        itSubSectionObj: null,
        effectiveDate: null,
        removed_by_user: true,
        create_arrear_component: false,
        tax_distributed_across_year: false,
        supperAnnuationPerk: false,
        deductionName: "None",
        editable_status: null,
        visible_in_it_proof:false
      },

      disableForm: {
        name: false,
        abbreviation: false,
        effectiveDate: false,
        roundOffObj: false,
        transaction_type: false,
        fixed: false,
        SalaryComponentType: false,
        CalculationType: false,
        formula: false,
        is_ffs_component:false,
        is_fbp_component: false,
        fbp_newregime_applicable: false,
        not_attendance_dependant: false,
        payable_if_full_lop: false,
        payable_if_employee_have_joined_before_a_date: false,
        active: false,
        consider_esi_deduction: false,
        consider_esi_eligibility: false,
        pt_applicability: false,
        taxable: false,
        gross_up_tax: false,
        pay_frequncy: false,

        ctcSubSection: false,
        allow_lower_declaration: false,
        allow_annual_claim: false,
        paid: false,
        carry_forward_next_fbp_year: false,
        PayoutFrequency: false,
        allow_full_claims_any_time: false,

        tax_distributed_across_year: false,
        create_arrear_component: false,
        carry_forward_excess_bills: false,
        reflect_this_in_payslip: false,
        allow_multiple_claims: false,
        isPFEligible: false,
        isPTEligible: false,
        itSubSectionObj: false,
        visible_in_it_proof:false,
      },

      finalFormula: "",
      bracketsData: ["(", ")", "[", "]", "{", "}"],
      operatorsData: ["+", "-", "*", "/", ")"],
      itSubSectionsArray: [],
      newAbbreviationData: [],
    };
  },

  mounted() {
    this.setEffectiveDateDateValidations();
  },

  activated() {
    this.setGlobalValidations();
    this.setConstantsData();
    this.setEffectiveDateDateValidations();

    try {
      this.showSlabs = false;

      if (this.salaryComponentsData[this.leId]){
        this.salaryComponentsData[this.leId].forEach(type => {
          this.newAbbreviationData.push(type.abbreviation);
        });
         this.newAbbreviationData.push('CTC');
        }

      if (this.$route.query.id) {
        let obj = this.salaryComponentsData[this.leId].find(
          item => item.id == this.$route.query.id
        );
        if (obj.calculation_on_actual) {
          obj.calculation_on_actual = this.calculationOnData.find(
            item => item.id == obj.calculation_on_actual
          );
        }

        this.formData = {
          name: obj.name,
          abbreviation: obj.abbreviation,
          create_arrear_component: obj.create_arrear_component
            ? obj.create_arrear_component
            : false,
          CalculationType: this.setCalculationType(obj.calculation_type),
          transaction_type: this.setTransactionType(obj.transaction_type),
          removed_by_user:
            obj.removed_by_user == null ? true : obj.removed_by_user,
          taxable: obj.taxable ? obj.taxable : false,
          tax_distributed_across_year: obj.tax_distributed_across_year
            ? obj.tax_distributed_across_year
            : false,
          gross_up_tax: obj.gross_up_tax,
          fixed:
            obj.salary_component_type == "FIXED"
              ? true
              : obj.salary_component_type == "VARIABLE"
              ? false
              : null,
          allow_auto_claim: obj.fbp_settings
            ? obj.fbp_settings.auto_claim
              ? obj.fbp_settings.auto_claim
              : false
            : false,
          allow_lower_declaration: obj.fbp_settings
            ? obj.fbp_settings.lower_declaration
              ? obj.fbp_settings.lower_declaration
              : false
            : false,
          allow_annual_claim: obj.fbp_settings
            ? obj.fbp_settings.annual_claim
              ? obj.fbp_settings.annual_claim
              : false
            : false,
          carry_forward_excess_bills: obj.fbp_settings
            ? obj.fbp_settings.carry_forward_bills
              ? obj.fbp_settings.carry_forward_bills
              : false
            : false,
          carry_forward_next_fbp_year: obj.fbp_settings
            ? obj.fbp_settings.carry_forward_unclaimed_amount_next_year
              ? obj.fbp_settings.carry_forward_unclaimed_amount_next_year
              : false
            : false,
          allow_full_claims_any_time: obj.fbp_settings
            ? obj.fbp_settings.full_claims_anytime
            : false,
          deductionName: obj.it_section ? obj.it_section : "None",
          fbp: obj.fbp ? obj.fbp : false,
          part_of_ctc: obj.part_of_ctc ? obj.part_of_ctc : false,
          reflect_this_in_payslip: obj.reflect_this_in_payslip
            ? obj.reflect_this_in_payslip
            : false,
          is_ffs_component: obj.is_ffs_component
          ? obj.is_ffs_component
          : false,
          is_fbp_component: obj.is_fbp_component
          ? obj.is_fbp_component
          : false,
          is_exempted_under_new_tax_regime:obj.is_exempted_under_new_tax_regime 
          ? obj.is_exempted_under_new_tax_regime
          : false,
          fbp_newregime_applicable: obj.fbp_newregime_applicable 
          ? obj.fbp_newregime_applicable
          : false,
          active: obj.active ? obj.active : false,
          visible_in_it_proof:obj.visible_in_it_proof?obj.visible_in_it_proof:false,
          SalaryComponentType: this.setPayType(obj.pay_type),
          paid: obj.paid ? obj.paid : false,
          consider_esi_deduction: obj.consider_esi_deduction
            ? obj.consider_esi_deduction
            : false,
          consider_esi_eligibility: obj.consider_esi_eligibility
            ? obj.consider_esi_eligibility
            : false,
          ffs_component: obj.ffs_component ? obj.ffs_component : false,
          minimumThreshold: obj.minimum_threshold,
          Token:obj.token,
          // EmailId:obj.emailId,
          // EmployeeId:obj.employeeId,
          not_attendance_dependant:
            obj.not_attendance_dependant == true ? false : true,
          payable_if_full_lop: obj.payable_if_full_lop
            ? obj.payable_if_full_lop
            : false,
          payable_if_employee_have_joined_before_a_date: obj.payable_if_employee_have_joined_before_a_date
            ? obj.payable_if_employee_have_joined_before_a_date
            : false,
          PayoutFrequency: "",
          cutoffDays: obj.cutoff_date ? obj.cutoff_date : 0,
          fixedOrVariable: obj.salary_component_type
            ? obj.salary_component_type
            : "",
          supperAnnuationPerk: obj.supperAnnuationPerk
            ? obj.supperAnnuationPerk
            : false,
          allow_multiple_claims: obj.multiple_claims
            ? obj.multiple_claims
            : false,
          pt_applicability: obj.pt_applicability ? obj.pt_applicability : false,
          effectiveDate: obj.calculation
            ? obj.calculation[0].effective_date
              ? obj.calculation[0].effective_date
              : null
            : null,
          formula:
            obj.calculation_type == "FLAT"
              ? obj.calculation
                ? isNaN(obj.calculation[0].formula)
                  ? 0
                  : obj.calculation[0].formula
                : 0
              : obj.calculation
              ? obj.calculation[0].formula
                ? obj.calculation[0].formula
                : null
              : null, // PL_2797
          ctcSubSection: obj.ctcSubSection ? obj.ctcSubSection : "NA",
          editable_status: obj.editable_status ? obj.editable_status : null
        };

        this.setItSubSection(obj.it_section, obj.itSubSectionID);
        this.setPayTypeDropDownList();
        this.setRoundOffValue(obj.round_off_type);
        this.setPayFrequencyType(obj.pay_frequncy), (this.rangeSlabArray = []);

        // if (obj.calculation_type == "SLAB") {
        //   if (obj.calculation) {
        //     if (obj.calculation[0].formula) {
        //       this.setSlabs(
        //         obj.calculation[0].formula,
        //         obj.calculation[0].unit
        //       );
        //     }
        //   }
        // } else {
        //   this.rangeSlabArray.push({
        //     from: null,
        //     to: null,
        //     unit: "",
        //     value: ""
        //   });
        // }

        if (!obj.removed_by_use) {
          this.setFormDisability(obj.editable_status);
        }
      } else {
        this.refresh();
      }
    } catch (error) {
      this.toast = true;
      this.errmsg = error;
    }
  },

  destroyed() {
    this.refresh();
  },

  beforeDestroy() {
    this.refresh();
  },

  computed: {
    ...mapState({
      componentTypes: state =>
        state.onboard.settings.salary_component_types.data,
      salaryComponentsData: state =>
        state.onboard.settings.salary_component.entityWiseData,
      globalData: state => state.globalapi.globalData,
      leData: state => state.onboard.legal_entities.data

    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    saveBtnText() {
      return !this.$route.query.id ? "Save" : "Update";
    },
    pageHeaderText() {
        return !this.$route.query.id
        ? "Add New Salary Component"
        : "Edit Salary Component";
    },

    disableAbbrevation(){
      return this.$route.query.id ? true : false;
    },
  },

  methods: {
    ...mapActions({
      act_create: "onboard/settings/salary_component/create",
      act_update: "onboard/settings/salary_component/update"
    }),
    /** Function to set form validations */
    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    
    setEffectiveDateDateValidations() {

      try {
        this.leIncorporationDate = this.leData[this.$route.params.entity_index]
          .incorporationDate
          ? this.leData[this.$route.params.entity_index].incorporationDate
          : null;

      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
      },
    /*** Function to Set Constants Data for drop downs ***/
    setConstantsData() {
      try {
        this.payoutFrequencyOptions =
          constants.SalaryComponentsConstants.payoutFrequencyList;
        this.roundOffData = constants.SalaryComponentsConstants.roundOffList;
        this.payFrequencyArray =
          constants.SalaryComponentsConstants.payFrequencyList;
        this.transactionTypeArray =
          constants.SalaryComponentsConstants.transactionTypeList;
        this.calculationTypeData =
          constants.SalaryComponentsConstants.calculationTypeList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /*** this.setFormDisability(obj.editable_status); ***/
    /** Function to set the form feilds in disabled mode based on certain conditions (editable_status) */
    setFormDisability(editable_status) {
      try {
        switch (editable_status) {
          case "None": {
            this.disableForm = {
              name: true,
              abbreviation: true,
              effectiveDate: true,
              roundOffObj: true,
              transaction_type: true,
              fixed: true,
              SalaryComponentType: true,
              CalculationType: true,
              formula: true,

              part_of_ctc: true,
              not_attendance_dependant: true,
              payable_if_full_lop: true,
              payable_if_employee_have_joined_before_a_date: true,
              active: true,
              consider_esi_deduction: true,
              consider_esi_eligibility: true,
              pt_applicability: true,
              taxable: true,
              gross_up_tax: true,
              pay_frequncy: true,

              ctcSubSection: true,
              allow_lower_declaration: true,
              allow_annual_claim: true,
              paid: true,
              carry_forward_next_fbp_year: true,
              PayoutFrequency: true,
              allow_full_claims_any_time: true,

              tax_distributed_across_year: true,
              create_arrear_component: true,
              carry_forward_excess_bills: true,
              reflect_this_in_payslip: true,
              allow_multiple_claims: true,
              isPFEligible: true,
              isPTEligible: true,
              itSubSectionObj: true,
              is_ffs_component:true,
              is_fbp_component: true,
              fbp_newregime_applicable: true,
              visible_in_it_proof:true,
            };
            break;
          }
          case "All": {
            this.disableForm = {
              name: false,
              abbreviation: false,
              effectiveDate: false,
              roundOffObj: false,
              transaction_type: false,
              fixed: false,
              SalaryComponentType: false,
              CalculationType: false,
              formula: false,

              part_of_ctc: false,
              not_attendance_dependant: false,
              payable_if_full_lop: false,
              payable_if_employee_have_joined_before_a_date: false,
              active: false,
              consider_esi_deduction: false,
              consider_esi_eligibility: false,
              pt_applicability: false,
              taxable: false,
              gross_up_tax: false,
              pay_frequncy: false,

              ctcSubSection: false,
              allow_lower_declaration: false,
              allow_annual_claim: false,
              paid: false,
              carry_forward_next_fbp_year: false,
              PayoutFrequency: false,
              allow_full_claims_any_time: false,

              tax_distributed_across_year: false,
              create_arrear_component: false,
              carry_forward_excess_bills: false,
              reflect_this_in_payslip: false,
              allow_multiple_claims: false,
              isPFEligible: false,
              isPTEligible: false,
              itSubSectionObj: false,
              is_ffs_component:false,
              is_fbp_component: false,
              fbp_newregime_applicable: false,
              visible_in_it_proof:false
            };
            break;
          }
          case "Transaction": {
            this.disableForm = {
              name: false,
              abbreviation: false,
              effectiveDate: false,
              roundOffObj: false,
              transaction_type: true,
              fixed: false,
              SalaryComponentType: false,
              CalculationType: false,
              formula: false,

              part_of_ctc: false,
              not_attendance_dependant: false,
              payable_if_full_lop: false,
              payable_if_employee_have_joined_before_a_date: false,
              active: false,
              consider_esi_deduction: false,
              consider_esi_eligibility: false,
              pt_applicability: false,
              taxable: false,
              gross_up_tax: false,
              pay_frequncy: false,

              ctcSubSection: false,
              allow_lower_declaration: false,
              allow_annual_claim: false,
              paid: false,
              carry_forward_next_fbp_year: false,
              PayoutFrequency: false,
              allow_full_claims_any_time: false,

              tax_distributed_across_year: false,
              create_arrear_component: false,
              carry_forward_excess_bills: false,
              reflect_this_in_payslip: false,
              allow_multiple_claims: false,
              isPFEligible: false,
              isPTEligible: false,
              itSubSectionObj: false,
              visible_in_it_proof:false
            };
            break;
          }
          case "Fixed": {
            this.disableForm = {
              name: false,
              abbreviation: false,
              effectiveDate: false,
              roundOffObj: false,
              transaction_type: true,
              fixed: true,
              SalaryComponentType: false,
              CalculationType: false,
              formula: false,

              part_of_ctc: false,
              not_attendance_dependant: false,
              payable_if_full_lop: false,
              payable_if_employee_have_joined_before_a_date: false,
              active: false,
              consider_esi_deduction: false,
              consider_esi_eligibility: false,
              pt_applicability: false,
              taxable: false,
              gross_up_tax: false,
              pay_frequncy: false,

              ctcSubSection: false,
              allow_lower_declaration: false,
              allow_annual_claim: false,
              paid: false,
              carry_forward_next_fbp_year: false,
              PayoutFrequency: false,
              allow_full_claims_any_time: false,

              tax_distributed_across_year: false,
              create_arrear_component: false,
              carry_forward_excess_bills: false,
              reflect_this_in_payslip: false,
              allow_multiple_claims: false,
              isPFEligible: false,
              isPTEligible: false,
              itSubSectionObj: false,
              visible_in_it_proof:false
            };
            break;
          }
          case "SA": {
            this.disableForm = {
              name: false,
              abbreviation: false,
              effectiveDate: false,
              roundOffObj: false,
              transaction_type: true,
              fixed: true,
              SalaryComponentType: false,
              CalculationType: true,
              formula: true,

              part_of_ctc: true,
              not_attendance_dependant: false,
              payable_if_full_lop: false,
              payable_if_employee_have_joined_before_a_date: false,
              active: true,
              consider_esi_deduction: false,
              consider_esi_eligibility: false,
              pt_applicability: false,
              taxable: false,
              gross_up_tax: false,
              pay_frequncy: false,

              ctcSubSection: false,
              allow_lower_declaration: false,
              allow_annual_claim: false,
              paid: false,
              carry_forward_next_fbp_year: false,
              PayoutFrequency: false,
              allow_full_claims_any_time: false,

              tax_distributed_across_year: false,
              create_arrear_component: false,
              carry_forward_excess_bills: false,
              reflect_this_in_payslip: false,
              allow_multiple_claims: false,
              isPFEligible: false,
              isPTEligible: false,
              itSubSectionObj: false,
              visible_in_it_proof:false
            };
            break;
          }
          case "Restricted": {
            this.disableForm = {
              name: false,
              abbreviation: false,
              effectiveDate: false,
              roundOffObj: false,
              transaction_type: false,
              fixed: true,
              SalaryComponentType: true,
              CalculationType: true,
              formula: true,

              part_of_ctc: false,
              not_attendance_dependant: false,
              payable_if_full_lop: false,
              payable_if_employee_have_joined_before_a_date: false,
              active: true,
              consider_esi_deduction: true,
              consider_esi_eligibility: true,
              pt_applicability: true,
              taxable: true,
              gross_up_tax: true,
              pay_frequncy: true,

              ctcSubSection: false,
              allow_lower_declaration: false,
              allow_annual_claim: false,
              paid: false,
              carry_forward_next_fbp_year: false,
              PayoutFrequency: false,
              allow_full_claims_any_time: false,

              tax_distributed_across_year: false,
              create_arrear_component: false,
              carry_forward_excess_bills: false,
              reflect_this_in_payslip: false,
              allow_multiple_claims: false,
              isPFEligible: false,
              isPTEligible: false,
              itSubSectionObj: false,
              visible_in_it_proof:false
            };
            break;
          }
          default:
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /*** Set Dropdown values to auto populate ***/
    setSlabs(formulaArray, unit) {
      try {
        if (formulaArray) {
          if (formulaArray.length) {
            this.rangeSlabArray = [];
            formulaArray.forEach(slabObj => {
              let obj = {
                from: slabObj.from,
                to: slabObj.to,
                value: slabObj.value,
                unit: unit
              };
              this.rangeSlabArray.push(obj);
            });
          }
        }

        this.copyRangeSlabArray = [...this.rangeSlabArray];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Set/Auto populate the Pay type drop down value */
    setPayType(pay_type) {
      if (pay_type == "FBP") {
        return "FBP Component";
      } else if (pay_type == "STATUTORY") {
        return "Statutory";
      } else if (pay_type == "NONE") {
        return "None";
      } else if (pay_type == "OVERTIME") {
        return "Overtime";
      } else if (pay_type == "Loan") {
        return "Loan";
      } else if (pay_type == "REIMBURSEMENT") {
        return "Reimbursement";
      } else {
        return null;
      }
    },
    /** Set/Auto populate the 'Transaction type' drop down value */
    setTransactionType(transaction_type) {
      if (transaction_type == "DEDUCTION") {
        return this.transactionTypeArray[0];
      } else if (transaction_type == "EARNING") {
        return this.transactionTypeArray[1];
      } else if (transaction_type == "NONE") {
        return this.transactionTypeArray[2];
      } else if (transaction_type == "REIMBURSEMENT") {
         return this.transactionTypeArray[3];
      } else {
        return null;
      }
    },
    /** Set /Auto populate the 'Calculation type' drop down value */
    setCalculationType(calculation_type) {
      if (calculation_type == "FLAT") {
        return "Flat";
      } else if (calculation_type == "FORMULA") {
        return "Formula";
      // } else if (calculation_type == "SLAB") {
      //   return "Slab";
      } else {
        return null;
      }
    },
    /** Set /Auto populate the 'Pay Frequency' drop down value */
    setPayFrequencyType(pay_frequncy) {
      try {
        if (pay_frequncy) {
          let payfrequencyIndex = this.payFrequencyArray.findIndex(
            ele => ele.id == pay_frequncy
          );
          if (payfrequencyIndex > -1) {
            this.formData.PayFrequency = this.payFrequencyArray[
              payfrequencyIndex
            ];
          }
        } else {
          this.formData.PayFrequency = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Set /Auto populate the 'Riund off' drop down value */
    setRoundOffValue(round_off_type) {
      try {
        if (round_off_type) {
          let roundOffIndex = this.roundOffData.findIndex(
            ele => ele.id == round_off_type
          );
          if (roundOffIndex > -1) {
            this.formData.roundOffObj = this.roundOffData[roundOffIndex];
          }
        } else {
          this.formData.roundOffObj = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Set the 'Pay type' drop down values based on certain conditions */
    setPayTypeDropDownList() {
      try {
        if (
          this.formData.transaction_type &&
          this.formData.transaction_type.name == "Earning"
        ) {
          if (this.formData.fixed == true || this.formData.fixed == "true") {
            this.SalaryComponentTypesArray = [
              // "FBP Component",
              // "Overtime",
              "Statutory",
              "Reimbursement",
              "None"
            ];
          } else {
            this.SalaryComponentTypesArray = [
              // "FBP Component",
              // "Overtime",
              "Reimbursement",
              "None"
            ];
          }
        } else if (
          this.formData.transaction_type &&
          this.formData.transaction_type.name == "Deduction"
        ) {
          if (this.formData.fixed == true || this.formData.fixed == "true") {
            this.SalaryComponentTypesArray = ["Statutory", "Loan", "None"];
          } else {
            this.SalaryComponentTypesArray = ["Loan", "None"];
          }
        } else if (
          this.formData.transaction_type &&
          this.formData.transaction_type == "None"
        ) {
          if (this.formData.fixed == true || this.formData.fixed == "true") {
            this.SalaryComponentTypesArray = ["Statutory"];
          } else {
            this.SalaryComponentTypesArray = ["Statutory"];
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Set IT Sub-section drop down values based on certain conditions */
    setItSubSection(it_section, itSubSectionID) {
      try {
        this.itSubSectionsArray = [];
          //console.log("check data",this.globalData.data)
        if (it_section == "Section10") {
          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "Section10") {
              this.itSubSectionsArray.push(item);
            }
          });
        } else if (it_section == "SectionVIA") {
          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "SectionVIA") {
              this.itSubSectionsArray.push(item);
            }
          });
        } else if (it_section == "Section17") {

          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "Section17") {
              this.itSubSectionsArray.push(item);
            }
          });
        }
        this.itSubSectionsArray = [...this.itSubSectionsArray];

        if (this.itSubSectionsArray.length) {
          if (itSubSectionID) {
            let subSectionIndex = this.itSubSectionsArray.findIndex(
              ele => ele.id == itSubSectionID
            );
            if (subSectionIndex > -1) {
              this.formData.itSubSectionObj = this.itSubSectionsArray[
                subSectionIndex
              ];
            }
          }
        } else {
          this.formData.itSubSectionObj = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /*** Onchange actions of dropdowns ***/

    /** On 'Calculation type' change */
    changeCalculationType(event) {
      if (event) {
        this.formData.CalculationType = event;
        this.formData.formula = 0;
      } else {
        this.formData.CalculationType = null;
        this.formData.formula = null;
      }
    },
    /** On 'Pay Frequency' change */
    changePayFrequency(event) {
      if (event) {
        this.formData.PayFrequency = event;
      } else {
        this.formData.PayFrequency = null;
      }
    },
    /** On 'Units val' change */
    unitValueChanged(event) {
      try {
        this.rangeSlabArray.forEach((item, index) => {
          this.rangeSlabArray[index].unit = event;
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Pay type' change */
    onPayTypeChange(val) {
      try {
        if (val == "FBP Component") {
          setTimeout(() => {
            this.formData.ctcSubSection = null;
            this.formData.part_of_ctc = false;
            this.formData.paid = false;
          }, 100);
        } else if (val == "Loan") {
          this.formData.ctcSubSection = null;
          this.formData.part_of_ctc = false;
        } else if (val == "Statutory") {
          if (
            this.formData.transaction_type &&
            this.formData.transaction_type.name == "None" &&
            this.formData.fixed
          ) {
            this.formData.ctcSubSection = null;
            this.formData.part_of_ctc = true;
          }
        } else if (val == "Overtime") {
          this.formData.ctcSubSection = null;
          this.formData.part_of_ctc = false;
        } else if (val == "Reimbursement") {
          this.formData.ctcSubSection = null;
          this.formData.part_of_ctc = false;
        } else if (val == "None") {
          // Pl-1427
          this.formData.ctcSubSection = null;
          this.formData.part_of_ctc = false;
          // Pl-1427
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Transaction type' change */
    onTransactionTypeChange(event) {
      try {
        this.formData.transaction_type = event ? event : null;
        //this.formData.SalaryComponentType = "";
        if (event && event.name == "None") {
          this.formData.fixed = true;
        }
        this.setPayTypeDropDownList();
        /**PL_2716 */
        if (this.formData.SalaryComponentType) {
          this.checkIsSelectedPayTypeOfTansactionTypeAvailable();
        }
        /**PL_2716 */
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Component Type' change */
    onComponentTypeChange() {
      try {
        this.formData.SalaryComponentType = null;
        this.formData.part_of_ctc = null;
        this.formData.ctcSubSection = null;
        this.setPayTypeDropDownList();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Tax status' radio button change */
    onTaxStatusChange(event) {
      try {
        if (!event || event == "false") {
          this.formData.tax_distributed_across_year = false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Deductions' radio buttons change */
    onDeductionChange(event) {
      try {
        this.formData.deductionName = event ? event : null;
        this.itSubSectionsArray = [];
        this.formData.itSubSectionObj = null;
        if (event == "SectionVIA") {
          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "SectionVIA") {
              this.itSubSectionsArray.push(item);
            }
          });
        } else if (event == "Section10") {
          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "Section10") {
              this.itSubSectionsArray.push(item);
            }
          });
        } else if (event == "Section17") {
          this.globalData.data.ITSubSection.forEach(item => {
            if (item.under_section == "Section17") {
              this.itSubSectionsArray.push(item);
            }
          });
        }
         else {
          this.itSubSectionsArray = [];
        }
        this.itSubSectionsArray = [...this.itSubSectionsArray];

        this.setTaxStatusValidations();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'IT Sub section' drop down change */
    onItSubSectionChange(event) {
      if (event){
        this.formData.itSubSectionObj = event;
      
      }else{
        this.formData.itSubSectionObj = null;
          
      }
    },

    /** Function to check the selected 'Pay type' for selected 'Transaction type' in certain conditions */
    /**PL_2716 */
    checkIsSelectedPayTypeOfTansactionTypeAvailable() {
      try {
        let selectedPayTypeExisted = this.SalaryComponentTypesArray.some(
          salCompObj => salCompObj == this.formData.SalaryComponentType
        );
        this.formData.SalaryComponentType = selectedPayTypeExisted
          ? this.formData.SalaryComponentType
          : "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /**PL_2716 */

    /** On 'Tax status' radio buttons change */
    /**PL_2207 */
    setTaxStatusValidations() {
      try {
        if (
          this.formData.deductionName == "Section10" ||
          this.formData.deductionName == "SectionVIA" ||
          this.formData.deductionName == "Section17"
        ) {
          this.formData.taxable = true;
        } else {
          this.formData.taxable = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /**PL_2207 */

    /*** Check box changes ***/

    /** On 'Dependent on Attendance' drop down change */
    depedentOnAttendanceClicked(event) {
      try {
        if (!event) {
          this.formData.payable_if_full_lop = null;
          this.formData.payable_if_employee_have_joined_before_a_date = null;
          this.formData.cutoffDays = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Part of CTC' check box change */
    onPartOfCTCchange(event) {
      try {
        if (this.formData.SalaryComponentType == "None") {
          if (event) {
            this.formData.ctcSubSection = null;
          } else {
            this.formData.ctcSubSection = null;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /*** Slabs actions / methods ***/

    /** On back button click of Slabs screen */
    backToAddSalaryComponent() {
      try {
        this.rangeSlabArray = [...this.copyRangeSlabArray];
        this.showSlabs = false;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On 'Add slab' click */
    addRangeSlab() {
      try {
        this.rangeSlabArray.push({
          from: null,
          to: null,
          unit: this.rangeSlabArray.length ? this.rangeSlabArray[0].unit : "",
          value: ""
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On delete slab click */
    deleteRangeSlab(index) {
      try {
        this.rangeSlabArray.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On click of add new slab in SC screen */
    addSlab() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.toast = false;
            this.errmsg = "";

            if (!this.rangeSlabArray.length) {
              this.rangeSlabArray.push({
                from: null,
                to: null,
                unit: "",
                value: ""
              });
            }
            this.showSlabs = true;
            this.copyRangeSlabArray = [...this.rangeSlabArray];
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    saveSlabs() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.showSlabs = false;
          } else {
            //Logic to focus the screen on validation error messages
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /*** To refresh/re-assign/reset the form  ***/
    refresh() {
      try {
        this.showSlabs = false;
        this.toast = false;
        this.formData = {
          name: null,
          calculationTypeID: "",
          roundOffID: "",
          fixed: true,
          active: false,
          taxable: true,
          CalculationType: null,
          calculationOnActual: {},
          SalaryComponentType: null,
          //PL-1427
          part_of_ctc: false,
          //PL-1427
          roundOffObj: null,
          PayFrequency: null,
          ctcSubSection: null, //PL_2509
          fixedOrVariable: "FixedGross",
          itSectionObj: null,
          itSubSectionObj: null,
          PayoutFrequency: null,
          effectiveDate: null,
          deductionName: "None",
          unit: null,
          create_arrear_component: null,
          tax_distributed_across_year: null
        };

        this.disableForm = {
          name: false,
          abbreviation: false,
          effectiveDate: false,
          roundOffObj: false,
          transaction_type: false,
          fixed: false,
          SalaryComponentType: false,
          CalculationType: false,
          formula: false,

          not_attendance_dependant: false,
          payable_if_full_lop: false,
          payable_if_employee_have_joined_before_a_date: false,
          active: false,
          consider_esi_deduction: false,
          consider_esi_eligibility: false,
          pt_applicability: false,
          taxable: false,
          gross_up_tax: false,
          pay_frequncy: false,

          ctcSubSection: false,
          allow_lower_declaration: false,
          allow_annual_claim: false,
          paid: false,
          carry_forward_next_fbp_year: false,
          PayoutFrequency: false,
          allow_full_claims_any_time: false,

          tax_distributed_across_year: false,
          create_arrear_component: false,
          carry_forward_excess_bills: false,
          reflect_this_in_payslip: false,
          allow_multiple_claims: false,
          isPFEligible: false,
          isPTEligible: false,
          itSubSectionObj: false
        };
        this.rangeSlabArray = [];
        this.itSubSectionsArray = [];
        this.finalFormula = "";
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Navigation handling */
    goBack() {
      this.refresh();
      // this.$router.push({
      //   path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`,
      //   params: {
      //     activeIndex: 3
      //   }
      // });
      this.$router.go(-1);
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
        if (this.formData.CalculationType == "Flat") {
          this.calctypeenum = "FLAT";
        } else if (this.formData.CalculationType == "Formula") {
          this.calctypeenum = "FORMULA";
        // } else if (this.formData.CalculationType == "Slab") {
        //   this.calctypeenum = "SLAB";
        } else {
          this.calctypeenum = null;
        }

        if (this.formData.SalaryComponentType == "FBP Component") {
          this.paytypeenum = "FBP";
        } else if (this.formData.SalaryComponentType == "Statutory") {
          this.paytypeenum = "STATUTORY";
        } else if (this.formData.SalaryComponentType == "None") {
          this.paytypeenum = "NONE";
        } else if (this.formData.SalaryComponentType == "Overtime") {
          this.paytypeenum = "OVERTIME";
        } else if (this.formData.SalaryComponentType == "Loan") {
          this.paytypeenum = "Loan";
        } else if (this.formData.SalaryComponentType == "Reimbursement") {
          this.paytypeenum = "REIMBURSEMENT";
          this.formData.taxable = false;
        } else {
          this.paytypeenum = null;
        }

        let obj = {
          le_id: this.leId,
          is_ffs_component:this.formData.is_ffs_component,
          is_fbp_component:this.formData.is_fbp_component,
          is_exempted_under_new_tax_regime:this.formData.is_exempted_under_new_tax_regime,
          fbp_newregime_applicable:this.formData.fbp_newregime_applicable,
          name: this.formData.name.toString().trim(),
          abbreviation: this.formData.abbreviation,
          round_off_type: this.formData.roundOffObj
            ? this.formData.roundOffObj.id
            : null,
          transaction_type: this.formData.transaction_type
            ? this.formData.transaction_type.id
            : null,
          salary_component_type:
            this.formData.fixed == "true" || this.formData.fixed == true
              ? "FIXED"
              : "VARIABLE",
          calculation_type: this.calctypeenum,
          pay_type: this.paytypeenum,
          pt_applicability: this.formData.pt_applicability
            ? this.formData.pt_applicability
            : false,

          active: this.formData.active ? this.formData.active : false,
          visible_in_it_proof:this.formData.visible_in_it_proof ? this.formData.visible_in_it_proof : false,
          part_of_ctc: this.formData.part_of_ctc
            ? this.formData.part_of_ctc
            : false,
          ctcSubSection: this.formData.ctcSubSection
            ? this.formData.ctcSubSection
            : "NA",
          consider_esi_eligibility: this.formData.consider_esi_eligibility
            ? this.formData.consider_esi_eligibility
            : false,
          consider_esi_deduction: this.formData.consider_esi_deduction
            ? this.formData.consider_esi_deduction
            : false,
          not_attendance_dependant:
            this.formData.not_attendance_dependant == true ? false : true,
          payable_if_full_lop: this.formData.payable_if_full_lop
            ? this.formData.payable_if_full_lop
            : false,
          payable_if_employee_have_joined_before_a_date: this.formData
            .payable_if_employee_have_joined_before_a_date
            ? this.formData.payable_if_employee_have_joined_before_a_date
            : false,
          cutoff_date: this.formData.cutoffDays ? this.formData.cutoffDays : 0,
          create_arrear_component: this.formData.create_arrear_component
            ? this.formData.create_arrear_component
            : false,
          paid: this.formData.paid ? this.formData.paid : false,
          reflect_this_in_payslip: this.formData.reflect_this_in_payslip
            ? this.formData.reflect_this_in_payslip
            : false,
          gross_up_tax: this.formData.gross_up_tax
            ? this.formData.gross_up_tax
            : false,
          taxable:
            this.formData.taxable == "true" || this.formData.taxable == true
              ? true
              : false,
          tax_distributed_across_year: Boolean(
            this.formData.tax_distributed_across_year
          ),
          pay_frequncy: this.formData.PayFrequency
            ? this.formData.PayFrequency.id
            : null,
          it_section: this.formData.deductionName,
          itSubSectionID:
            this.formData.itSubSectionObj != null &&
            this.formData.itSubSectionObj != {}
              ? this.formData.itSubSectionObj
                ? this.formData.itSubSectionObj.id
                : null
              : null,

          minimum_threshold: 0,
          token: window.localStorage.getItem('token'),
          // emailId: window.localStorage.getItem('loginId'),
          // employeeId: window.localStorage.getItem('employeeId'),
          //supperAnnuationPerk: this.formData.supperAnnuationPerk,
          fbp_settings: {
            auto_claim: this.formData.allow_auto_claim ? true : false,
            lower_declaration: this.formData.allow_lower_declaration
              ? true
              : false,
            carry_forward_bills: this.formData.carry_forward_bills
              ? true
              : false,
            carry_forward_unclaimed_amount_next_year: this.formData
              .carry_forward_next_fbp_year
              ? true
              : false,
            full_claims_anytime: this.formData.allow_full_claims_any_time
              ? true
              : false,
            multiple_claims: this.formData.allow_multiple_claims ? true : false,
            annual_claim: this.formData.allow_annual_claim ? true : false
          }
        };

        let formulaArray = [];
        let unit = null;

        // if (this.formData.CalculationType == "Slab") {
        //   this.rangeSlabArray.forEach(slabObj => {
        //     let obj = {
        //       from: slabObj.from,
        //       to: slabObj.to,
        //       value: slabObj.value
        //     };
        //     formulaArray.push(obj);
        //     unit = slabObj.unit;
        //   });
        //
        //   let calculationObj = {
        //     effective_date: this.formData.effectiveDate
        //       ? this.formData.effectiveDate
        //       : null,
        //     formula: formulaArray,
        //     unit: unit
        //   };
        //   obj.calculation = [calculationObj];
        // } else {
          let calculationObj = {
            effective_date: this.formData.effectiveDate
              ? this.formData.effectiveDate
              : null,
            formula:
              this.formData.CalculationType == "Formula"
                ? this.formData.formula
                  ? this.formData.formula
                  : 0
                : this.formData.CalculationType == "Flat"
                ? this.formData.formula
                  ? this.formData.formula
                  : 0
                : null,
            unit: null
          };
          obj.calculation = [calculationObj];
        // }

        try {
          if (!this.$route.query.id) {
            obj.ctcSubSection = this.formData.ctcSubSection
              ? this.formData.ctcSubSection
              : "NA";
            obj.removed_by_user = true;

            this.$root._data.isSaving = true;
            let res = await this.act_create({ data: obj });

            setTimeout(() => {
              if (res.data.status) {
                this.popupMessage = res.data.message;
                this.showSuccessMsg = true;
              }
              this.$root._data.isSaving = false;
            }, 500);
          } else if (this.$route.query.id) {
            obj.id = this.$route.query.id;
            obj.removed_by_user = this.formData.removed_by_user;
            obj.editable_status = this.formData.editable_status;

            this.$root._data.isSaving = true;
            let res = await this.act_update({ data: obj });

            setTimeout(() => {
              if (res.data.status) {
                this.popupMessage = res.data.message;
                this.showSuccessMsg = true;
              }
              this.$root._data.isSaving = false;
            }, 500);
          }
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    //** Function to validate the form */
    async save() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction();
          } else {
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** To save the formula entered in a formula builder */
    async saveExpression() {
      try {
        if (this.isValidExpression) {
          this.formData.formula = this.finalFormula.replace(/'/g, "");
          this.cancelModal();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On back click of slabs screen */
    goBackFromSlabs() {
      this.showSlabs = false;
    },
    cancelModal() {
      this.showCreateModal = false;
    },

    /** ON generate formula button click */
    /** PL_2789 */
    generateFormula() {
      this.finalFormula = "";
      this.afterSavingExpression = false;
      this.isValidExpression = false;
      this.showCreateModal = true;
    },
    /** PL_2789 */

    backfrompopup() {
      this.showSuccessMsg = false;
      this.refresh();
      this.$router.go(-1);
    },
    /** Function to check the validation of the given formula */
    onValidExpression() {
      try {
         let abbreviationArray=this.newAbbreviationData;
         let formula1=`^((\\d+(\\.?\\d+))[*-+/])*([\\[\\(\\{]['](`;
         let formula2=`)['][\\]\\)\\}]([*-+/][0-9]+(.?[0-9]+))*)([*-+/][\\[\\(\\{]['](`;
         let formula3=`)['][\\]\\)\\}]([*-+/][0-9]+(.?[0-9]+))*)*`;
         var Abbreviations="";
         for(let i=0;i<abbreviationArray.length;i++)
         {
           if(i==0)
           {
            Abbreviations=Abbreviations+abbreviationArray[i];
           }
           else
           {
            Abbreviations=Abbreviations+"|"+abbreviationArray[i];
           }
         }
         let finalString=formula1+Abbreviations+formula2+Abbreviations+formula3;
         let stringFinalFormula = this.finalFormula.toString();
         var re = new RegExp(finalString,'g');
        //  let formulaRegex = config.Regex.FORMULA;
        let result = stringFinalFormula.match(re);
        
        if(result[0]==stringFinalFormula)
        {
         this.afterSavingExpression = true;
         this.isValidExpression = true;
        }
        else
        {
         this.afterSavingExpression = true;
         this.isValidExpression = false;
        }

      } catch (error) {
        this.afterSavingExpression = true;
        this.isValidExpression = false;
      }
    },
    brackets(event) {
      //Start PL-1979
      if (event) {
        this.finalFormula += event;
      }
      //End PL-1979
    },
    abbreviation(event) {
      //Start PL-1979
      if (event) {
        let addQuotes = "'" + event + "'";
        this.finalFormula += addQuotes.toString();
      }
      //End PL-1979
    },
    operators(event) {
      //Start PL-1979
      if (event) {
        this.finalFormula += event;
      }
      //End PL-1979
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.custom-width {
  width: auto;
}

.top-bar {
  height: 64px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.custom-width-100 {
  width: 100px;
  margin-top: -16px;
}
.customtaxable{
  padding-left:143px;
}
.preferences {
  width: 100%;
  margin-bottom: 110px;
}

.label {
  width: 100%;
  margin-top: 30px;
}
//start of custom-width-radio for Deduction
.custom-radio-width {
  padding: 0;
  width: 110px;
  margin-right: 10px !important;
  label {
    width: 110px;
  }
}
//end of custom-width-radio for Deduction

.preferences-form .input-field {
  width: 224px;
  height: 35px;
  margin-top: 5px;
  border: 1px solid #8b9c9c;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #ffffff;
  outline: 0;
  color: #000000;
}

.inline {
  display: flex;
  width: 100%;
  align-items: flex-end;
}

.inline img {
  height: 9px;
  width: 10px;
  margin: 0px 6px;
}

.check {
  display: flex;
  align-self: center;
}

.checkmark {
  border-radius: 4px;
}

.arrow-up img {
  transform: rotate(180deg);
}

.twoColumnGrid-tax {
  margin-left: 638px;
  width: 100%;
}

.radio-margin-top {
  margin-top: 20px;
  margin-bottom: 20px;
}

.add-flex-new-basis {
  flex-basis: 340px;
}
.modal-custom-width-select {
  width: 130px;
}

.selectdiv select {
  width: 100%;
  max-width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("../../../../../../assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

.display-flex {
  display: -webkit-box;
}

.radio-button-section {
  display: flex;
}
.displayPayslip {
  margin-top: -100px;
}
.ffs_component{
  margin-top: -100px;
}
.footer-width {
  width: 90%;
}
.slabsClass {
  width: 65px;
  height: 15px;
  font-size: 12px;
  color: #5d409f;
  cursor: pointer;
  margin-top: 84px;
  margin-left: -328px;
}
.flex-container {
  display: flex;
}
.input-label-tax {
  margin-left: 638px;
  width: 100%;
  margin-top: -75px;
}
.taxstatusClass {
  margin-left: 638px;
  width: 100%;
  margin-top: -175px;
}
.line {
  margin-top: -15px;
  width: 66px;
  height: 1px;
  border: solid 1px #5d409f;
  margin-bottom: 10px;
  cursor: pointer;
  margin-top: 100px;
  margin-left: -65px;
}
.flex-container > div {
  margin-left: 10px;
  margin-right: 10px;
  flex-basis: 222px;
}
.displayDed {
  margin-top: -60px;
}
.flex-container {
  &.flex-basis-auto > div {
    flex-basis: auto;
  }
  .add-new-flex-basis {
    flex-basis: 444px;
  }
}
.marginleft-90p {
  margin-left: 302px;
  width: 303px;
  margin-top: -24px;
}
.threeColumnGrid {
  display: grid;
  grid-template-columns: 300px 300px 300px;
  grid-row-gap: 24px;
  grid-column-gap: 32px;
  &.threeColumnGrid-auto {
    grid-template-columns: auto auto auto;
    grid-column-gap: 20px;
  }
}
.marginleft {
  margin-left: 634px;
  margin-top: -18px;
  width: 100%;
}
.alignDed {
  display: flex;
}
.bottom-75 {
  margin-bottom: 75px;
}
.allowmulclaims {
  margin-top: -170px;
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}
.formsubheader {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
.customwidth {
  width: 300px;
  margin-right: 32px;
}
.content-new {
  margin: 20px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0;
}
.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.payoutFrequency {
  margin-left: 212%;
  width: 600px;
  margin-top: -90px;
}
.multipleClaims{
  margin-left: 212%;
  width: 600px;
  margin-top: -78px;
}
select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

.margin-t-l {
  margin-left: 30px;
}
.range {
  display: flex;
  > div {
    margin-right: 100px;
  }
}
.customheadcheck{
  padding-top: 15px;
}
.payFrequency {
  margin-top: 100px;
}
.content-new {
  margin: 32px;
}
</style>